import { Get, Post, Put, Delete } from '../../api/axiosCoreConfig';
import { createQueryParamsFromObject } from '../../api/helper';

export const getPatients = (namespace, params, isHintSearch) =>
    Get(`/patient${isHintSearch ? '/hint' : ''}?namespace=${namespace}`, {
        params: createQueryParamsFromObject(params)
    });
export const createPatient = (patient) => Post('/patient', patient);
export const getPatientDetail = (patientId, namespace, clinicId) =>
    Get(`/patient/${patientId}?clinic=${clinicId}&namespace=${namespace}`);
export const editPatient = (patientId, patient) => Put(`/patient/${patientId}`, patient);
export const deletePatient = (patientId, namespace) =>
    Delete(`/patient/${patientId}?namespace=${namespace}`);
// export const getAllPatientsReport = (namespace) =>
//     Get(`/patient/export${namespace ? '?namespace=' + namespace : ''}`, { responseType: 'blob' });
export const summonPatient = (patientId, clinicId, namespace) =>
    Post(`/patient/${patientId}/summon/clinic/${clinicId}`, { namespace });
